module.exports = __webpack_public_path__ + "static/media/imgop_caseStudies.c868b115.jp2";